import React, { Component } from "react";

export default class MobileDecorations extends Component {
  render() {
    return (
      <div className="relative">
        <button
          name="scroll-right"
          className="m-0 button-shadow-right scroll"
        ></button>

        <ul>
          {this.props.activeDecorationType !== "" &&
            this.props.decorations[this.props.activeDecorationType].map(
              (decoration) => (
                <li
                  key={"decorationImage" + decoration.id}
                  onClick={(evt) => {
                    evt.preventDefault();
                    this.props.selectHandler(decoration);
                  }}
                  className={
                    this.props.selected.indexOf(decoration.id) >= 0
                      ? "active"
                      : ""
                  }
                >
                  {" "}
                  {decoration.image && (
                    <img src={decoration.image} alt="cover" />
                  )}{" "}
                </li>
              )
            )}
        </ul>
        <button
          name="scroll-left"
          className="m-0 button-shadow-left scroll"
        ></button>
      </div>
    );
  }
}
